import { render, staticRenderFns } from "./ApproveForms.modal.vue?vue&type=template&id=432612d6&scoped=true&"
import script from "./ApproveForms.modal.vue?vue&type=script&lang=ts&"
export * from "./ApproveForms.modal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "432612d6",
  null
  
)

export default component.exports